import { render, staticRenderFns } from "./supplementary-document.vue?vue&type=template&id=57edf4bf&scoped=true&"
import script from "./supplementary-document.vue?vue&type=script&lang=js&"
export * from "./supplementary-document.vue?vue&type=script&lang=js&"
import style0 from "./supplementary-document.vue?vue&type=style&index=0&id=57edf4bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57edf4bf",
  null
  
)

export default component.exports